<template>
  <div v-if="!loading">
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:new="createHandler"
      v-on:save="saveHandler"
      v-on:delete="isConfirm = !isConfirm"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
    <div v-if="isConfirm">
      <app-confirm
        v-bind:parentObject="{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }"
        v-on:confirm="deleteHandler($event)"
        v-on:cancelConfirm="isConfirm = !isConfirm"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";

import ThisForm from "../../../components/payroll/socsosub/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": ThisForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('allsocso.editsocsosubmissionrec'),
      pageTitleValue: "",
      formData: [],
      headLoading: true,
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadHeaderHandler() {
      const vm = this;

      this.$store.dispatch('get', {url: "/socsosubmissionrecord/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          vm.pageTitleValue = res.data.rec[0].socsosubreccode;
          vm.formData.userid = this.$store.getters.userId;

          vm.loadDetailHandlerPay();

          //vm.headLoading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadDetailHandlerPay() {
      const vm = this;
      console.log("id", this.id);

      this.$store.dispatch('get', {url: "/socsosubmissionrecordpy/" + this.id})
        .then((res) => {
          vm.formData.socsosubrecpay = res.data.rec;

           for (let i = 0; i < vm.formData.socsosubrecpay.length; i++) {

            // vm.formData.socsosubrecpay[i].pyctrlid = res.data.rec[0].pyctrlid;
            // vm.formData.socsosubrecpay[i].socsosubrecid = res.data.rec[0].socsosubrecid;
            // vm.formData.socsosubrecpay[i].payoutcode = res.data.rec[0].payoutcode;
            // vm.formData.socsosubrecpay[i].payoutdesc = res.data.rec[0].payoutdesc;
            // vm.formData.socsosubrecpay[i].pystatuscode = res.data.rec[0].pystatuscode;
            // vm.formData.socsosubrecpay[i].pystatusdesc = res.data.rec[0].pystatusdesc;

            Object.assign(vm.formData.socsosubrecpay[i], { action: 2 });
          }

          vm.loadDetailHandlerRef();
          // vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadDetailHandlerRef() {
      const vm = this;

      this.$store.dispatch('get', {url: "/socsosubmissionrecordref/" + this.id})
        .then((res) => {
          vm.formData.socsosubrecref = res.data.rec;

          console.log('subref', vm.formData.socsosubrecref)

          for (let i = 0; i < vm.formData.socsosubrecref.length; i++) {
            if (vm.formData.socsosubrecref[i].receiptdate) {
              vm.formData.socsosubrecref[i].receiptdate = moment(
                vm.formData.socsosubrecref[i].receiptdate
              ).format("YYYY-MM-DD");
            }
          }


           for (let i = 0; i < vm.formData.socsosubrecref.length; i++) {
            Object.assign(vm.formData.socsosubrecref[i], { action: 2 });
            Object.assign(vm.formData.socsosubrecref[i], { no: i + 1 });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
        this.$router.push({name: 'socsosubnew'});
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      this.$store.dispatch('put', {url: "/socsosubmissionrecord/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "socsosublist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "socsosublist" });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/socsosubmissionrecord/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "socsosublist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  mounted() {
    this.loadHeaderHandler();
    // this.loadDetailHandlerPay();
    // this.loadDetailHandlerRef();
  },
};
</script>